import { Switch } from "@/components/ui/switch";
import Tooltip from "@mui/material/Tooltip";
import { LABELS } from "../../utils/labels";

const ResponseVariable = ({
  updateNodeFun,
  selectedNodeInfo,
  iseditable,
}) => {
  return (
    <div className="response-container">
      <p>{LABELS.SAVE_RESPONSE_VARIABLE}</p>
      <Tooltip title="Enable to show in chat summary">
        <span>
          <Switch
            checked={
              selectedNodeInfo?.data.isShowInChatHistory
                ? selectedNodeInfo?.data.isShowInChatHistory
                : false
            }
            onCheckedChange={(checked) => {
              updateNodeFun(selectedNodeInfo.id, {
                ...selectedNodeInfo?.data,
                isShowInChatHistory: checked,
              });
            }}
            disabled={!iseditable}
          />
        </span>
      </Tooltip>
    </div>
  );
};

export default ResponseVariable;
